import { render, staticRenderFns } from "./EvaluationReport.vue?vue&type=template&id=622d80d4&scoped=true"
import script from "./EvaluationReport.vue?vue&type=script&lang=js"
export * from "./EvaluationReport.vue?vue&type=script&lang=js"
import style0 from "./EvaluationReport.vue?vue&type=style&index=0&id=622d80d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d80d4",
  null
  
)

export default component.exports